import KeyIcon from "@/assets/icons/key.svg";

import StatusPage, { StatusPageProps } from "..";

const NotFound: React.FunctionComponent<Partial<StatusPageProps>> = (props) => {
  return (
    <StatusPage
      data-testid="not-found"
      icon={KeyIcon}
      title={L.STATUS_PAGE_NOT_FOUND_TITLE}
      subtitle={L.STATUS_PAGE_NOT_FOUND_SUBTITLE}
      {...props}
    />
  );
};

export default NotFound;
